<script setup lang="ts">
import type { AggregationFilterEntityOption } from '~/types/shopware'

const props = defineProps<{
  filterOptions: AggregationFilterEntityOption[]
  currentFilters: {
    properties: string[]
  }
}>()

const emits = defineEmits<{
  (e: 'select-value', value: { code: string; value: string[] }): void
}>()

const selectedOptionIds = computed(() => props.currentFilters?.properties || [])

const onToggleOption = (entity: { code: string; id: string }) => {
  let options: string[] = []
  if (selectedOptionIds.value.includes(entity.id)) {
    options = selectedOptionIds.value.filter((entry) => entry != entity.id)
  } else {
    options = [...selectedOptionIds.value, entity.id]
  }

  emits('select-value', {
    code: entity.code,
    value: options,
  })
}

const computedFilterOptions = computed(() => props.filterOptions)
</script>

<template>
  <div class="filter-tag">
    <div class="inner">
      <Tag
        v-for="option in computedFilterOptions"
        :key="option.id"
        v-animate="{ animation: 'vertical-reveal' }"
        :name="option.name || option.translated?.name || ''"
        :active="selectedOptionIds?.includes(option.id)"
        @click="onToggleOption({ code: 'properties', id: option.id })"
      >
        <template #icon>
          <Icon
            v-if="option.translated?.customFields?.custom_property_fields_type_property_code === 'e-book'"
            class="variant-icon"
            name="ebook"
          />
          <Icon
            v-if="option.translated?.customFields?.custom_property_fields_type_property_code === 'print'"
            class="variant-icon"
            name="book"
          />
          <Icon
            v-if="option.translated?.customFields?.custom_property_fields_type_property_code === 'learning-card'"
            class="variant-icon"
            name="showcases"
          />
          <Icon
            v-if="option.translated?.customFields?.custom_property_fields_type_property_code === 'combi'"
            class="variant-icon"
            name="combo"
          />
          <Icon
            v-if="option.translated?.customFields?.custom_property_fields_type_property_code === 'set'"
            class="variant-icon"
            name="set"
          />
        </template>
      </Tag>
    </div>
  </div>
</template>
<style scoped lang="scss">
.filter-tag {
  .inner {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 4px;
  }
}
</style>
